import _ from "lodash";
import { ajax, ll } from "../../../framework";
import K_SingularListBox from "../templates/K_SingularListBox";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface SingularListBoxOptions extends InputOptions, kendo.ui.ListBoxOptions {
    id: string;
    listBoxId?: string;
    baseEntityType?: string;
    selectFields?: string[];
    expands?: string[];
    filter?: string;
    sortField?: string;
    listBoxObservableArray?: kendo.data.ObservableArray;
    // tslint:disable-next-line:ban-types
    listBoxTemplate?: string|Function;
    listBoxLabel?: string;
    listBoxClasses?: string;
    searchEnabled?: boolean;
    searchPlaceholder?: string;
    listBoxSearchFields?: string[];
    usingLocalData?: boolean;
}

export class SingularListBox extends TemplateComponent {

    options: SingularListBoxOptions;
    listBox: kendo.ui.ListBox;
    fullList: any[];

    constructor(options: SingularListBoxOptions) {
        super(K_SingularListBox, options);
    }

    preRender() {
        this.options.screenEntityType = this.options.screenEntityType || "";
        this.fullList = [];

        this.options.selectFields = this.options.selectFields || [];
        this.options.expands = this.options.expands || [];
        this.options.listBoxLabel = ll(this.options.listBoxLabel) || "";
        this.options.searchEnabled = this.options.searchEnabled || false;
        this.options.usingLocalData = this.options.usingLocalData || false;

        if (this.options.searchEnabled) {
            this.options.searchPlaceholder = ll(this.options.searchPlaceholder) || ll("Search");
        }

        // Provide some basic default functions for reordering the dataSource & to support auto scrolling when the draggable option is true and if custom functions are not provided.
        if (this.options.draggable) {
            // This will ensure that the data items in the data source get reordered properly as the user drags and drops items in the list box.
            if (!this.options.reorder) {
                this.options.reorder = function (e) {
                    e.preventDefault();
                    var dataSource = e.sender.dataSource;
                    var dataItem = e.dataItems[0];
                    var index = dataSource.indexOf(dataItem) + e.offset;
                    dataSource.remove(dataItem);
                    dataSource.insert(index, dataItem);
                };
            }

            /* This will enable autoscrolling of the list box when dragging an item if a custom dataBound function is not provided. This comes from a Kendo product suggestion post:
             * https://feedback.telerik.com/kendo-jquery-ui/1464004-add-autoscroll-configuration-option-for-listbox-draggable */
            if (!this.options.dataBound) {
                this.options.dataBound = function (e) {
                    var wrapper = e.sender.wrapper;
                    setTimeout(function () {
                        var draggable = wrapper.data("kendoDraggable");
                        draggable.setOptions({
                            autoScroll:true
                        });
                    });
                }
            }
        }
    }

    create() {
        var me = this;
        $("#" + me.options.id).attr("screenentitytype", me.options.screenEntityType);

        if (me.options.baseEntityType) {
            var url = `${me.options.baseEntityType}?$top=10000`;

            if (me.options.selectFields.length > 0) {
                url += `&$select=${me.options.selectFields.join(",")}`;
            }

            if (me.options.expands.length > 0) {
                url += `&$expand=${me.options.expands.join(",")}`;
            }

            if (me.options.filter) {
                url += `&$filter=${me.options.filter}`;
            }

            if (me.options.sortField) {
                url += `&$orderby=${me.options.sortField}`;
            }

            ajax({ url: url }).done(function (data){
                me.setDataSource(data.d.results);
            });
        }

        me.options.template = me.options.listBoxTemplate;
        me.listBox = $("#" + me.options.listBoxId).kendoListBox(me.options).data("kendoListBox");
        $("#" + me.options.listBoxId).after(`<div class='z-none-found-message'>${ll("GridNoDataFound")}</div>`);

        delete me.options.toolbar;

        if (me.options.searchEnabled) {
            if (me.options.listBoxSearchFields) {
                $("#SearchListBox").on("input", function () {
                    var searchString = $(this).val();
                    var filter = { logic: "or", filters: [] };
                    me.options.listBoxSearchFields.forEach(searchField => {
                        filter.filters.push({ field: searchField, operator: "contains", value: searchString });
                    });
                    // filtering clears out the list of selected items, so grab the current selections to reapply to the list box before setting the filter
                    var selectedItems = me.listBox.select();
                    me.listBox.dataSource.filter(filter);
                    me.retainListBoxSelections(me.listBox, selectedItems);
                });
            }
        }
    }

    retainListBoxSelections(listBox: kendo.ui.ListBox, selectedItems: JQuery) {
        if (selectedItems?.length > 0) {
            $(selectedItems).each(function (index) {
                let dataItem = listBox.dataItem(selectedItems[index]);
                if (dataItem) {
                    let uid = dataItem.uid;
                    let item = listBox.wrapper.find("[data-uid='"+uid+"']");
                    if (item) {
                        item.addClass("k-state-selected");
                    }
                }
            });
        }
    }

    setDataSource(list: any[]) {
        var me = this;
        me.fullList = list;
        me.listBox.setDataSource(new kendo.data.DataSource({ data: list }));
    }
}
